import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import "../../styles/injuredPlayersCard.css"

export default function InjuredPlayersCard({ stats }) {
    const [isOpen, setIsOpen] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(null);

    useEffect(() => {
        fetch("https://focifanatik.hu/api/session_check.php", {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (!data.loggedIn) {
                    setIsLoggedIn(false);
                }
                else if (data.loggedIn) {
                    setIsLoggedIn(true);
                }
            });
    }, []);

    return (
        <div className='injured-stat-card'>

            <div className='injured-stat-title' onClick={() => setIsOpen(!isOpen)}>
                Sérült/Eltiltott játékosok
            </div>

            {isOpen && (

                isLoggedIn ?
                    (
                        <>
                            <div className="stat-card-border">
                                <div className='injured-stat-header'>
                                    <img src={`/images/teams/${stats.teams.home.logo}`} alt={stats.teams.home.name} />
                                    <img src={`/images/teams/${stats.teams.away.logo}`} alt={stats.teams.away.name} />
                                </div>

                                <div className='injured-stat-list'>
                                    {stats.injured.map(inj => {
                                        return (
                                            <div className='injured-stat-row'>

                                                <span className='injured-stat-value'>
                                                    {inj.home_value}
                                                </span>

                                                <span className='injured-stat-value'>
                                                    {inj.away_value}
                                                </span>

                                            </div>
                                        )
                                    })}

                                </div>
                            </div>

                        </>
                    )
                    :
                    (
                        <div className="stats-locked-card">

                            <div className="lock-icon">
                                🔒
                            </div>

                            <h3>Részletes statisztikák</h3>

                            <p>
                                Jelentkezz be vagy regisztrálj a teljes statisztikák
                                megtekintéséhez.
                            </p>

                            <div className="stats-lock-buttons">
                                <Link to="/bejelentkezes"><button className="login-btn">Bejelentkezés</button></Link>
                                <Link to="/regisztracio"><button className="register-btn">Regisztráció</button></Link>

                            </div>

                        </div>
                    )


            )}



        </div>
    )
}
